import React, { useEffect, useState } from "react";
import { Form, Input, Button, Table, Row, Col, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import style from "./style.module.scss";
import "./dashboardStyle.scss";
import { selectMobileDeviceState } from "../../../redux/feature/screen/screenSlice";

import { getPlanList, choosePlan , updatePlan} from "../../../redux/services";
import { planTableDateIndex } from "../../staticObjects";
import { Modal } from "antd";
import CardForm from './cardPaymentModal'

function PaymentPlan(props) {
    const dispatch = useDispatch();
    let { plans } = useSelector((state) => state.plan);
    const { data } = useSelector((state) => state?.user);
    const isMobileDevice = useSelector(selectMobileDeviceState);

    // Add custom mobile styles
    useEffect(() => {
      if (isMobileDevice) {
        const style = document.createElement('style');
        style.id = 'mobile-payment-card-styles';
        style.innerHTML = `
          @media (max-width: 576px) {
            .mobile-update-card-container {
              width: 100% !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            .mobile-update-card {
              width: 100% !important;
              min-width: 100% !important;
              max-width: 100% !important;
            }
            .mobile-update-card .ant-card-head-title {
              white-space: normal !important;
              word-break: break-word !important;
              font-size: 16px !important;
            }
            .mobile-update-card .ant-card-body {
              padding: 15px 10px !important;
            }
            .payment-modal-mobile {
              width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
              max-width: 100% !important;
              top: 50% !important;
              transform: translateY(-50%)
              
            }
            .payment-modal-mobile .ant-modal-content {
              border-radius: 0 !important;
            }
            .payment-modal-mobile .ant-modal-body {
              padding: 15px !important;
            }
            .payment-modal-mobile .ant-modal-header {
              padding: 10px !important;
            }
            .payment-modal-mobile .ant-modal-title {
              font-size: 16px !important;
            }
          }
        `;
        document.head.appendChild(style);
        
        return () => {
          const existingStyle = document.getElementById('mobile-payment-card-styles');
          if (existingStyle) {
            existingStyle.remove();
          }
        };
      }
    }, [isMobileDevice]);

    const [showCardPaymentModal, setShowCardPaymentModal] = useState(false);
    const [subscriptionData, setSubscriptionData] = useState({});
    if(props.update){
        plans  = plans.filter(plan =>  plan.price > data.active_plan.price )
    }



    const { frequency, duration, price, name, action } = planTableDateIndex;
    const ListTableCol = [
        { dataIndex: name, title: "Name" },
        { dataIndex: frequency, title: "Frequency " },
        { dataIndex: duration, title: "Duration (in days) " },
        { dataIndex: price, title: "price (in $)" },
        { dataIndex: action, title: "Action" },
    ];

    const ChoosePlan = (plan) => {
        setSubscriptionData(plan)
        setShowCardPaymentModal(true)
    };

  const onCardSubmit = (card) => {
    const planDetails = { ...card, ...subscriptionData }
    if (props.update || subscriptionData?.error) {
      dispatch(updatePlan(planDetails))
    } else {
      dispatch(choosePlan(planDetails))
    }
  }

    const handleCancel = () => {
        setSubscriptionData({})
        setShowCardPaymentModal(false)
    }



    const dataList = (plans) => {
        if (plans) {
            return plans.map((item) => ({
                ...item, // Keep all existing properties of the item
                action: (
                    <div className={style.buyData}>
                        <button
                            style={{ margin: "2px" }}
                            onClick={() => ChoosePlan(item)}
                        >
                            Choose Plan
                        </button>
                    </div>
                ),
            }));
        } else {
            return [];
        }
    };

    useEffect(() => {
        dispatch(getPlanList());
    }, []);

  return (
    <>
      {data.active_plan?.error || props.update_card
        ? 
      <div>
      <div className={style.pricesData}>
        <div className={`${style.home__prices}`} style={{margin: '20px'}}>
          <h4>Update Card Details</h4>
        </div>
      </div>
      <div className={`${style.asset} assetTable`}>
          <div className="plansNew mobile-update-card-container" style={{ width: '100%' }}>
            <Row gutter={[16, 16]} justify="center" style={{ margin: '0 !important', width: '100% !important' }}>
                <Col xs={24} sm={20} md={16} lg={12} className="mobile-update-card-container">
                  <Card
                    title={data.active_plan?.error ? 'Payment Failed' : 'Update Payment Method'}
                    bordered={false}
                    className="mobile-update-card"
                    style={{ 
                      textAlign: 'center', 
                      marginBottom: '20px', 
                      width: '100% !important',
                    }}
                    headStyle={{ 
                      fontSize: '18px', 
                      padding: '12px 16px',
                    }}
                    bodyStyle={{ 
                      padding: '24px',
                    }}
                  >
                    {
                      data.active_plan?.card_last_four_digit && 
                      <p>Card: **** **** **** {data.active_plan.card_last_four_digit}</p>
                    }
                    
                    {data.active_plan?.error && <p>Error: {data.active_plan.error}</p>}

                    <Button type="primary" onClick={() => ChoosePlan(data.active_plan || {})}>
                      {data.active_plan?.error ? 'Update Card & Pay' : 'Update Card'}
                    </Button>
                    
                    <p style={{ 
                      marginTop: '15px', 
                      fontWeight: '600',
                      color: '#e36464',
                      fontSize: '12px', 
                      textAlign: 'left',
                      wordBreak: 'break-word !important'
                    }}>
                      Please note that during the payment process, a temporary authorization hold of 0.01 cents will be placed on your account for verification purposes. This is not an actual charge, and the amount will not be deducted. Once the verification is complete, the hold will be released.
                    </p>
                  </Card>
                </Col>
              </Row>
          </div>
         </div>
        </div> :
        <div>
        <div className={style.pricesData}>
          <div className={`${style.home__prices}`} style={{margin: '20px'}}>
            <h4>Plan List</h4>
          </div>
        </div>
        <div className={`${style.asset} assetTable`}>
          {/* <Table
            rowKey={(obj) => obj.keyId}
            columns={ListTableCol}
            dataSource={dataList(plans)}
            pagination={false}
            className="priceTable"
            style={{ boxShadow: "none" }}
          /> */}
                    <div className="plansNew">
                        {data.role === 'broker' &&
                        <div style={{margin: '20px'}}>
                            NOTE:
                            <span style={{margin: '0px 0px 0px 8px', fontWeight: 'bold'}}>
            Broker is automatically upgraded to the Team plans when broker agent count lies in between the
            plans agent range. Pricing will be calculated accordingly.
            </span>
                            <br />
                            <br />
                            <span style={{ fontWeight: '600', color: '#e36464'}}>
Please note that during the sign-up or payment process, a temporary authorization hold of 0.01 cents will be placed on your account for verification purposes. This is not an actual charge, and the amount will not be deducted. Once the verification is complete, the hold will be released.
                            </span>
                        </div>}
                        <div style={{
                            width: '100%',
                            background: 'linear-gradient(135deg, #3b5d85, #4b719c)',
                            borderRadius: '12px',
                            padding: '30px 20px',
                            marginBottom: '40px',
                            position: 'relative',
                            overflow: 'hidden',
                            boxShadow: '0 10px 30px rgba(75, 113, 156, 0.25)'
                        }}>
                            {/* Abstract shapes for background */}
                            <div style={{
                                position: 'absolute',
                                width: '200px',
                                height: '200px',
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.1)',
                                top: '-100px',
                                right: '-50px'
                            }}></div>
                            <div style={{
                                position: 'absolute',
                                width: '150px',
                                height: '150px',
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.07)',
                                bottom: '-70px',
                                left: '10%'
                            }}></div>

                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                position: 'relative',
                                zIndex: 2
                            }}>
                                <div style={{
                                    flex: '1 1 400px',
                                    paddingRight: '20px',
                                    marginBottom: '20px'
                                }}>
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#ffffff',
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        display: 'inline-block',
                                        padding: '6px 12px',
                                        borderRadius: '20px',
                                        marginBottom: '15px'
                                    }}>
                                        SPECIAL OFFER
                                    </div>
                                    <h2 style={{
                                        fontSize: '32px',
                                        fontWeight: '700',
                                        color: '#ffffff',
                                        marginBottom: '15px'
                                    }}>
                                        Free 30-day Trial
                                    </h2>
                                    <p style={{
                                        fontSize: '16px',
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        marginBottom: '5px'
                                    }}>
                                        Experience all premium features with no limitations
                                    </p>
                                    <p style={{
                                        fontSize: '16px',
                                        color: 'rgba(255, 255, 255, 0.9)'
                                    }}>
                                    </p>
                                </div>

                                <div style={{
                                    flex: '0 0 auto',
                                    textAlign: 'center'
                                }}>
                                    {/*<Button*/}
                                    {/*    type="primary"*/}
                                    {/*    size="large"*/}
                                    {/*    style={{*/}
                                    {/*        background: '#ffffff',*/}
                                    {/*        color: '#4b719c',*/}
                                    {/*        border: 'none',*/}
                                    {/*        height: '50px',*/}
                                    {/*        borderRadius: '8px',*/}
                                    {/*        fontWeight: '700',*/}
                                    {/*        padding: '0 32px',*/}
                                    {/*        fontSize: '16px',*/}
                                    {/*        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',*/}
                                    {/*        transition: 'transform 0.2s ease, box-shadow 0.2s ease'*/}
                                    {/*    }}*/}
                                    {/*    onMouseOver={(e) => {*/}
                                    {/*        e.currentTarget.style.transform = 'translateY(-3px)';*/}
                                    {/*        e.currentTarget.style.boxShadow = '0 7px 20px rgba(0, 0, 0, 0.2)';*/}
                                    {/*    }}*/}
                                    {/*    onMouseOut={(e) => {*/}
                                    {/*        e.currentTarget.style.transform = 'translateY(0)';*/}
                                    {/*        e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.15)';*/}
                                    {/*    }}*/}
                                    {/*>*/}
                                    {/*    Get Started Now*/}
                                    {/*</Button>*/}
                                </div>
                            </div>
                        </div>                        <Row gutter={16}>
                            {plans.map((plan, index) => (
                                <Col xs={24} sm={12} md={6} key={index}>
                                    <Card
                                        // title={plan.name.toUpperCase()}
                                        title={'INDIVIDUAL PLAN'}
                                        bordered={false}
                                        // className={plan.name === 'Silver' ? 'plan-card selected-plan' : plan.class}
                                        style={{ textAlign: 'center', marginBottom: '20px' }}
                                    >
                                        <p><strong>Price: </strong>${plan.price}/month</p>
                                        { data.role == 'agent' ?
                                            <p><strong>Unlimited Access </strong></p>
                                            :
                                            <p><strong>Agents: </strong>{plan.number_of_connections}</p>
                                        }

                                        <Button type="primary" onClick={() => ChoosePlan(plan)}>Choose Plan</Button>
                                    </Card>
                                </Col>
                            ))}
                            {data.role === 'broker' &&
                            <>
                                <Col xs={24} sm={12} md={6}>
                                    <Card
                                        title={'SMALL TEAM'}
                                        bordered={false}
                                        // className={plan.name === 'Silver' ? 'plan-card selected-plan' : plan.class}
                                        style={{ textAlign: 'center', marginBottom: '20px' }}
                                    >
                                        <p><strong>Price Per Agent: </strong>$9/month</p>
                                        {
                                            <p><strong>Agents: </strong>51-250</p>
                                        }
                                        <Button type="primary" style={{background: '#4B719C', color: 'white'}} disabled>Auto Upgrade</Button>

                                    </Card>
                                </Col>

                <Col xs={24} sm={12} md={6}>
                  <Card
                    title={'MEDIUM TEAM'}
                    bordered={false}
                    // className={plan.name === 'Silver' ? 'plan-card selected-plan' : plan.class}
                    style={{ textAlign: 'center', marginBottom: '20px' }}
                  >
                    <p><strong>Price Per Agent: </strong>$7/month</p>
                    {  
                      <p><strong>Agents: </strong>251-500</p>
                    }
                    <Button type="primary" style={{background: '#4B719C', color: 'white'}} disabled>Auto Upgrade</Button>               
                  </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Card
                    title={'LARGE TEAM'}
                    bordered={false}
                    // className={plan.name === 'Silver' ? 'plan-card selected-plan' : plan.class}
                    style={{ textAlign: 'center', marginBottom: '20px' }}
                  >
                    <p><strong>Price Per Agent: </strong>$6/month</p>
                    {  
                      <p><strong>Agents: </strong>501-2000</p>
                    }
                    <Button type="primary" style={{background: '#4B719C', color: 'white'}} disabled>Auto Upgrade</Button>
                  </Card>
                </Col>
                </>}
            </Row>
          </div>
        </div>
      </div>
      }

            <Modal
                title={"Enter Card Details"}
                visible={showCardPaymentModal}
                onCancel={handleCancel}
                footer={null} // Disable default footer
                className={`add-new-agent ${isMobileDevice ? 'payment-modal-mobile' : ''}`}
                width={isMobileDevice ? "100%" : "40vw"}
                bodyStyle={{ 
                  padding: isMobileDevice ? '15px' : '50px', 
                  maxHeight: '90vh', 
                  overflowY: 'auto', 
                  margin: isMobileDevice ? '0' : '10px' 
                }}
                style={{ top: isMobileDevice ? 0 : 100 }}
                destroyOnClose={true}
            >
                <CardForm onSubmit={onCardSubmit} onCancel={handleCancel} />
            </Modal>
        </>
    );
}

export default PaymentPlan;
